<figure class="quiz-figure" [class.is-loading]="state === 'loading'" [class.has-error]="state === 'error'"
  [attr.aria-busy]="state === 'loading'">
  <div *ngIf="state !== 'loaded'" class="quiz-figure-placeholder"
    [attr.aria-hidden]="state === 'loading' || null">
    <ng-container *ngIf="state === 'error'">
      <i class="fas fa-image"></i>
      <span>{{ "quiz.image_error" | translate }}</span>
    </ng-container>
  </div>
  <img #image [src]="src" [alt]="alt" [attr.loading]="lazy ? 'lazy' : null" decoding="async" (load)="onLoad()"
    (error)="onError()" />
</figure>
